// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3vAnF","empty":"ModalGraph_empty__2JWKA"};